import React from "react";
import Header from "./Header";
import Footer from "./Footer"; // ✅ IMPORTA IL FOOTER
import useAuth from "../hooks/useAuth";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user } = useAuth();

  // Se non c'è utente, non renderizzare il layout
  if (!user) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f9fa",
        display: "flex", // ✅ AGGIUNGI FLEXBOX
        flexDirection: "column", // ✅ COLONNA VERTICALE
      }}
    >
      <Header />
      <main
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "20px",
          flex: 1, // ✅ OCCUPA SPAZIO DISPONIBILE
          width: "100%",
        }}
      >
        {children}
      </main>
      <Footer /> {/* ✅ AGGIUNGI IL FOOTER */}
    </div>
  );
};

export default Layout;
